var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_9718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_9718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.6781H20V15.0055H9V17.6781ZM4 8.3617H7V5.68917H4V8.3617ZM4 13.0324H7V10.3598H4V13.0324ZM4 17.6781H7V15.0055H4V17.6781ZM9 13.0324H20V10.3598H9V13.0324ZM9 8.3617H20V5.68917H9V8.3617ZM4 19.6762C3.45 19.6762 2.97933 19.4807 2.588 19.0898C2.196 18.6981 2 18.2276 2 17.6781V5.68917C2 5.13968 2.196 4.66945 2.588 4.27848C2.97933 3.88684 3.45 3.69102 4 3.69102H20C20.55 3.69102 21.021 3.88684 21.413 4.27848C21.8043 4.66945 22 5.13968 22 5.68917V17.6781C22 18.2276 21.8043 18.6981 21.413 19.0898C21.021 19.4807 20.55 19.6762 20 19.6762H4Z",
    fill: "#453F3A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewList);
export default __webpack_public_path__ + "static/media/view_list.df0fa2e1b0074711e107925e3c00f97b.svg";
export { ForwardRef as ReactComponent };